export default {
  text: {
    order_cancelled: 'Commande annulée - Aucun livreur disponible',
    wolt_support: 'Des questions ? Appelez Wolt directement <underline>{{phone_number}}</underline>',
    order_not_confirmed: '<strong>URGENT :</strong> Acceptez ou refusez cette commande immédiatement',
    no_driver_found: '<strong>Aucun livreur trouvé.</strong> Livrez cette commande vous-même ou annulez-la',
  },
  labels: {
    dummy_order: 'Commande test',
    items_one: '{{count}} article',
    items_other: '{{count}} articles',
    needs_acceptance: "En attente d'acceptation",
    driver_pending: "En attente d'un livreur",
    driver_search_retrying: 'Recherche de livreur en cours',
    no_driver_found: 'Aucun livreur trouvé',
    today: "Aujourd'hui",
    driver_assigned: 'Livreur assigné',
    complete: 'Terminée',
  },
  buttons: {
    complete_order: 'Marquer comme terminée',
    looking_for_driver: "Recherche d'un livreur...",
    click_to_remove: 'Cliquer pour supprimer',
  },
};
